import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("path", _objectSpread({
      d: "M22.855 8.12855C22.855 7.06286 22.5771 6.05129 22.0838 5.14062C23.248 6.48259 23.9376 8.13288 23.9376 9.91741\n         C23.9376 13.8017 20.6788 17.0508 16.3185 17.8692H16.3362C16.3191 17.8692 16.3021 17.8727 16.2852 17.8762\n         C16.2748 17.8783 16.2644 17.8804 16.2541 17.8817C16.232 17.8856 16.21 17.8899 16.1879 17.8941\n         C16.1586 17.8997 16.1292 17.9054 16.0993 17.9103C15.019 18.2602 14.1647 20.8653 14.1647 20.8653\n         C14.1647 20.8653 13.2387 18.2485 12.2089 17.9073C12.1922 17.9045 12.1758 17.9013 12.1595 17.8982\n         C12.1405 17.8945 12.1215 17.8908 12.1021 17.8878C12.0931 17.886 12.0841 17.884 12.0751 17.882\n         C12.0471 17.8758 12.019 17.8696 11.9902 17.8696H12.0096C7.6489 17.0512 4.39013 13.8021 4.39013 9.91784\n         C4.39013 8.13288 5.0788 6.48433 6.24432 5.14062C5.75019 6.05129 5.47221 7.06286 5.47221 8.12855\n         C5.47221 12.1332 9.36345 15.3792 14.1643 15.3792C18.9634 15.3792 22.855 12.1332 22.855 8.12855Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M14.1634 11.5287C12.2963 11.5287 10.5385 11.834 8.99556 12.371C8.19578 11.7855 7.56244 11.0675 7.15391 10.2595\n         C9.14859 9.3627 11.5618 8.83613 14.1634 8.83613C16.7646 8.83613 19.1769 9.36313 21.1712 10.2595\n         C20.764 11.0675 20.1306 11.7859 19.3308 12.371C17.7879 11.834 16.0306 11.5287 14.1634 11.5287Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M4.10351 21.7656C2.6237 20.4224 1.75 18.7738 1.75 16.9884C1.75 15.4091 2.43738 13.936 3.62105 12.688\n         C3.91416 13.4713 4.3309 14.2075 4.85054 14.886C3.75939 16.0111 3.12346 17.3444 3.12346 18.7768\n         C3.12346 19.843 3.47536 20.8541 4.10351 21.7656Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M24.7071 12.688C24.4135 13.4713 23.9968 14.2096 23.4771 14.8869C24.5683 16.0119 25.2034 17.3452 25.2034 18.7768\n         C25.2034 19.843 24.8523 20.8541 24.2225 21.7656C25.7027 20.4224 26.5781 18.7738 26.5781 16.9884\n         C26.5781 15.4091 25.8907 13.936 24.7071 12.688Z"
    }, args))]
  });
};
var ViewBox = "0 0 28 28";
var _Amarr = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "#E7B815" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 28 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_Amarr.displayName = "Amarr";
var Amarr = withSubcomponents(_Amarr, {
  Path: Path,
  ViewBox: ViewBox
});
export { Amarr };